import { FinishMarkerType } from '@tiendanube/common';

/**
 * Special marker indicating the questionnaire should end
 */
export const FINISH_MARKER: FinishMarkerType = '__finish__';
